const styles = {
  container: {
    display: 'flex',
    backgroundColor: 'white',
  },
};
export default styles;
